export default __webpack_public_path__ + "static/media/checkBig.97283fe5.svg";